import { supabaseClient } from "@/lib/supabase";
import { queryOptions, useQuery } from "@tanstack/react-query";

import { injection_contents_root_key } from "./selectInjectionContents";

/** Builder (admin) list: every row of the base table, whatever its Public flag. */
async function getInjectionContentsForBuilder() {
    const { data } = await supabaseClient.from("injection_contents").select("*").throwOnError();
    return data ?? [];
}

export const injection_contents_builder_key = [...injection_contents_root_key, "builder"];

export const injectionContentsBuilderQueryOptions = () => {
    return queryOptions({
        queryKey: injection_contents_builder_key,
        queryFn: async () => getInjectionContentsForBuilder(),
    });
};

export function useInjectionContentsBuilderQuery() {
    return useQuery(injectionContentsBuilderQueryOptions());
}
